import FILTER_KEYS from './FILTER_KEYS';

export const EVENT_DEBUGGER_LOCATION_STATE_KEY = 'eventDebugger';

export default function buildEventDebuggerLocationState({ clusterId, writekey, integrationId }) {
  return {
    [EVENT_DEBUGGER_LOCATION_STATE_KEY]: {
      clusterId,
      filters: {
        [FILTER_KEYS.WRITEKEYS]: [writekey],
        [FILTER_KEYS.INTEGRATION_IDS]: [integrationId],
      },
    },
  };
}
